import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemaSection from './components/ProblemaSection';
import SolucionSection from './components/SolucionSection';
import AISection from './components/AISection';
import OfertaSection from './components/OfertaSection';
import FAQSection from './components/FAQSection';
import CheckoutSection from './components/CheckoutSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <ProblemaSection />
      <SolucionSection />
      <AISection />
      <OfertaSection />
      <FAQSection />
      <CheckoutSection />
      <FooterSection />
    </main>
  );
}
